<template>
  <b-alert
    :variant="variant"
    dismissible
    :show="dismissCountDown"
    @dismissed="dismissCountDown=0"
    @dismiss-count-down="countDownChanged"
  >
    <h5 class="alert-heading text-uppercase">{{variant}}!</h5>
    <p class="my-2">{{defaultMsg}}</p>
    <b-progress :variant="variant" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress>
    <p class="my-2">{{ message }}</p>
  </b-alert>
</template>
<script>
export default {
  props: {
    variant: String,
    message: String
  },
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 0,
      defaultMsg: null
    };
  },
  name: "Alert",
  computed: {
    showAlert() {
      return this.$store.getters["alert/showAlert"];
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
      if (this.dismissCountDown == 0) {
        //this.$store.commit("alert/setShowAlert", false);
        //this.$store.commit("alert/setMessage");
      }
    },
    startAlert() {
      this.dismissCountDown = this.dismissSecs;
    }
  },
  watch: {
    showAlert() {
      if (this.variant === "success") {
        this.defaultMsg = "Request processing success...";
        this.startAlert();
      } else if (this.variant === "warning") {
        this.defaultMsg = "Request processing failed...";
        this.startAlert();
      }
    }
  }
};
</script>
<style scoped></style>